import { CropTypes, SoilTypes } from 'utils/types';

type SoilStatus = {
  [key in SoilTypes]: string;
};

type TableTargetStatusType = {
  [key in CropTypes]: SoilStatus;
};

export const tableTargetStatus: TableTargetStatusType = {
  [CropTypes.Grassland]: {
    [SoilTypes.Sand]: '5,1',
    [SoilTypes['Sandiger Schl Lehm']]: '6,1',
    [SoilTypes['Schwach Lehm Sand']]: '5,5',
    [SoilTypes['Stark Lehm Sand']]: '5,8',
    [SoilTypes['Toniger Lehm b.Ton']]: '6,3',
  },
  [CropTypes.OtherCrops]: {
    [SoilTypes.Sand]: '5,8',
    [SoilTypes['Sandiger Schl Lehm']]: '7',
    [SoilTypes['Schwach Lehm Sand']]: '6,3',
    [SoilTypes['Stark Lehm Sand']]: '6,7',
    [SoilTypes['Toniger Lehm b.Ton']]: '7,2',
  },
};

export const tableValuesPrice = {
  [CropTypes.Grassland]: {
    [SoilTypes.Sand]: {
      less: {
        value: 3.4,
        reply: 50,
      },
      between: {
        firstValue: 4.6,
        secondValue: 5.2,
        firstReply: -8,
        secondReply: 41.6,
      },
      more: {
        value: 5.1,
        reply: 0,
      },
      default: {
        firstValue: -37.692,
        secondValue: 178.46,
      },
      equal: 1,
    },
    [SoilTypes['Schwach Lehm Sand']]: {
      less: {
        value: 3.3,
        reply: 83,
      },
      between: {
        firstValue: 4.9,
        secondValue: 5.6,
        firstReply: -13.333,
        secondReply: 74.667,
      },
      more: {
        value: 5.5,
        reply: 0,
      },
      default: {
        firstValue: -46.348,
        secondValue: 235.91,
      },
      equal: 8/4,
    },
    [SoilTypes['Stark Lehm Sand']]: {
      less: {
        value: 3.8,
        reply: 90,
      },
      between: {
        firstValue: 5.1,
        secondValue: 5.9,
        firstReply: -14.286,
        secondReply: 84.286,
      },
      more: {
        value: 5.8,
        reply: 0,
      },
      default: {
        firstValue: -60.989,
        secondValue: 322.04,
      },
      equal: 10/4,
    },
    [SoilTypes['Sandiger Schl Lehm']]: {
      less: {
        value: 3.8,
        reply: 109,
      },
      between: {
        firstValue: 5.3,
        secondValue: 6.2,
        firstReply: -16.25,
        secondReply: 100.75,
      },
      more: {
        value: 6.1,
        reply: 0,
      },
      default: {
        firstValue: -63.309,
        secondValue: 349.87,
      },
      equal: 13/4,
    },
    [SoilTypes['Toniger Lehm b.Ton']]: {
      less: {
        value: 3.8,
        reply: 121,
      },
      between: {
        firstValue: 5.4,
        secondValue: 6.4,
        firstReply: -17.778,
        secondReply: 113.78,
      },
      more: {
        value: 6.3,
        reply: 0,
      },
      default: {
        firstValue: -65,
        secondValue: 368.24,
      },
      equal: 16/4,
    },
  },
  [CropTypes.OtherCrops]: {
    [SoilTypes.Sand]: {
      less: {
        value: 4,
        reply: 45,
      },
      between: {
        firstValue: 5.3,
        secondValue: 5.9,
        firstReply: -11.852,
        secondReply: 69.93,
      },
      more: {
        value: 5.8,
        reply: 0,
      },
      default: {
        firstValue: -28.945,
        secondValue: 160.52,
      },
      equal: 6/4,
    },
    [SoilTypes['Schwach Lehm Sand']]: {
      less: {
        value: 4,
        reply: 77,
      },
      between: {
        firstValue: 5.7,
        secondValue: 6.4,
        firstReply: -16.667,
        secondReply: 106.67,
      },
      more: {
        value: 6.3,
        reply: 0,
      },
      default: {
        firstValue: -38.71,
        secondValue: 231.47,
      },
      equal: 10/4,
    },
    [SoilTypes['Stark Lehm Sand']]: {
      less: {
        value: 4.5,
        reply: 87,
      },
      between: {
        firstValue: 6,
        secondValue: 6.8,
        firstReply: -20,
        secondReply: 136,
      },
      more: {
        value: 6.7,
        reply: 0,
      },
      default: {
        firstValue: -47.912,
        secondValue: 302.54,
      },
      equal: 14/4,
    },
    [SoilTypes['Sandiger Schl Lehm']]: {
      less: {
        value: 4.5,
        reply: 117,
      },
      between: {
        firstValue: 6.2,
        secondValue: 7.1,
        firstReply: -21.25,
        secondReply: 150.87,
      },
      more: {
        value: 7,
        reply: 0,
      },
      default: {
        firstValue: -58.122,
        secondValue: 378.54,
      },
      equal: 17/4,
    },
    [SoilTypes['Toniger Lehm b.Ton']]: {
      less: {
        value: 4.5,
        reply: 160,
      },
      between: {
        firstValue: 6.3,
        secondValue: 7.3,
        firstReply: -22.222,
        secondReply: 162.22,
      },
      more: {
        value: 7.2,
        reply: 0,
      },
      default: {
        firstValue: -76.93,
        secondValue: 505.53,
      },
      equal: 20/4,
    },
  },
};